<script lang="ts" context="module">
  export enum GalleryItemEvent {
    OPENED_MENU = 'opened-menu'
  }
</script>

<script lang="ts">
  import Swal from 'sweetalert2';
  import {doNotHidePopupOnNextClick, hidePopupOnNextClick} from '../../PopupBox/PopupBox.svelte';
  import {onMount} from 'svelte';
  import {tooltip} from '@/actions/tippy-action';

  export let item: any;
  export let addImage;

  export let deleteImage: () => any;
  let toggled = false;
  const toggleOptions = () => {
    console.log('Toggle options');
    toggled = !toggled;
    if (toggled) {
      const event = new CustomEvent(GalleryItemEvent.OPENED_MENU, {detail: {item}});
      window.dispatchEvent(event);
    }
  };
  function handleDelete() {
    setTimeout(() => {
      doNotHidePopupOnNextClick(true); // This will prevent the image popup sidebarr from closing when delete confirmation is clicked
    }, 250); // The timeout is required to debounce the click event which sometimes causes it to trigger a hide event
    console.log('Delete image', item);
    Swal.fire({
      title: 'Are you sure you want to delete this image?',
      showCancelButton: true,
      didClose: () => {
        hidePopupOnNextClick(); // This reactivates the default functionality of the image popup sidebar on click (anywhere on the page it will close)
      }
    }).then(result => {
      if (result.isConfirmed) {
        deleteImage();
      }
    });
  }

  onMount(() => {
    window.addEventListener(GalleryItemEvent.OPENED_MENU, (event: any) => {
      console.log('item event opened');
      const eventItem = event.detail.item;
      if (item == eventItem) return;
      toggled = false;
    });
  });
</script>

<div class="relative cursor-pointer">
  <img
    on:click={() => addImage(item)}
    on:keydown={() => addImage(item)}
    src={item.file.publicUrl}
    alt={item.name}
    class="h-32 w-full rounded-md object-cover"
  />
  <div class="absolute right-0 top-0 flex h-6 w-6 items-center justify-center rounded-full bg-white p-1 text-white">
    <i
      use:tooltip={'Delete'}
      class="fa fa-trash text-xs text-gray-300 hover:text-red-500"
      on:click={handleDelete}
      on:keypress={handleDelete}
    ></i>
    <!-- <i class="fa fa-circle-ellipsis text-lg" on:keypress={toggleOptions} on:click={toggleOptions}></i> -->
  </div>
  <div
    class="toggledOptions absolute left-0 top-0 h-full w-full {toggled
      ? ''
      : 'hidden'} flex items-center justify-center align-middle"
  >
    <div
      class="absolute left-0 top-0 z-10 h-full w-full bg-gray-800 opacity-40"
      on:click|stopPropagation|self={toggleOptions}
      on:keypress|stopPropagation|self={toggleOptions}
    ></div>
    <div class="z-20 rounded-md bg-white p-2 text-xs">
      <div class="text-red-500 hover:text-red-700" on:click={handleDelete} on:keypress={handleDelete}>
        <i class="fa fa-trash"></i>
        <span class="inline-block font-semibold">Delete Image</span>
      </div>
    </div>
  </div>
</div>
